export default __webpack_public_path__ + "static/media/authorized_2.5df60fe1.png";